import { Component } from '@angular/core';
import { SVGIcon, searchIcon } from '@progress/kendo-svg-icons';
import { AbstractComponent } from 'src/app/shared/components/abstract-component';
import { process } from '@progress/kendo-data-query';
import { IhmsService } from 'src/app/shared/services/ihms.service';
import { filter, take, takeUntil } from 'rxjs';
import { IHMSResponse } from 'src/app/shared/interfaces/ihms-dashboard-response';
import { AuthStore } from 'src/app/stores/auth.store';
import { User } from 'src/app/shared/models/user';
import { Router } from '@angular/router';
import { RoutesConstantService } from 'src/app/services/routes-constant.service';

@Component({
  selector: 'app-ihms-action-items',
  templateUrl: './ihms-action-items.component.html',
  styleUrls: ['./ihms-action-items.component.scss'],
  standalone: false,
})
export class IhmsActionItemsComponent extends AbstractComponent {
  public searchIcon: SVGIcon = searchIcon;
  public allActionItems: IHMSResponse[] = [];
  public gridView: IHMSResponse[] = [];
  public userDetails: User;
  public loadSpinner: boolean = false;

  constructor(
    public ihmsService: IhmsService,
    private authStore: AuthStore,
    public router: Router,
    public routesConstantService: RoutesConstantService
  ) {
    super();
    this.authStore.UserInfo$.pipe(
      filter((user: User) => !!user),
       
      take(1)
    ).subscribe((user: User) => {
      this.userDetails = user;
      this.getIHMSGridData();
    });
    this.ihmsService.reloadIhmsGridData$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((data: boolean) => {
        if (data) {
          this.getIHMSGridData();
        }
      });
  }

  getIHMSGridData(): void {
    this.ihmsService.loadingIhmsActions = true;
    /*if(this.userDetails?.isGlobalUser == true && this.userDetails?.csLocation != undefined && this.userDetails?.csLocation != null){
      this.ihmsService
      .getIHMSDashboardGrid(this.userDetails.csLocation.replace('CS', 'CPSE-'))
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((response: IHMSDashboardResponse) => {
        this.ihmsService.loadingIhmsActions = false;
        this.allActionItems = [...response.iHMSData];
        this.gridView = [...this.allActionItems];
      });
    }*/
  }

  public handleActionItemsSearch(query: Event): void {
    const inputValue: Event = query;
    this.gridView = process(this.allActionItems, {
      filter: {
        logic: 'or',
        filters: [
          { field: 'nycID', operator: 'contains', value: inputValue },
          { field: 'studentName', operator: 'contains', value: inputValue },
        ],
      },
    }).data;
  }

  routeToStudentProfile(studentId: string): void {
    if (studentId) {
      this.router.navigate([
        this.routesConstantService.routes.studentInformationPage,
        studentId,
      ]);
    }
  }

  override afterOnDestroy(): void {
    // Cleanup if needed
  }
}
